import { render, staticRenderFns } from "./aplyshop.vue?vue&type=template&id=005752df&scoped=true"
import script from "./aplyshop.vue?vue&type=script&lang=js"
export * from "./aplyshop.vue?vue&type=script&lang=js"
import style0 from "./aplyshop.vue?vue&type=style&index=0&id=005752df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005752df",
  null
  
)

export default component.exports